import { Flex } from '@chakra-ui/react';
import React from 'react';

import { Typography } from '~/packages/common-frontend/components/Typography';
import { useCreditFacilityContext } from '~/packages/credit-facility/hooks/CreditFacilityProvider';
import {
  chargeOffAndDelinquentOverviewChartConfig,
  collectionsAccountChartConfig,
  daysPastDueChartConfig,
} from '~/packages/portfolio/ui/profitLoss/profitLossChartConfigs';
import { ProfitLossOverviewChartTemplate } from '~/packages/portfolio/ui/profitLoss/ProfitLossOverviewChartTemplate';
import { ProfitLossVintageChartTemplate } from '~/packages/portfolio/ui/profitLoss/ProfitLossVintageChartTemplate';
import { RepaymentsVintageChart } from '~/packages/portfolio/ui/profitLoss/RepaymentsVintageChart';
import { PortfolioCoreBorrowingBaseChartTemplate } from '~/packages/portfolio/ui/shared/PortfolioCoreBorrowingBaseChartTemplate';

export const BorrowerPerformanceContainer = () => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Flex direction="column" gap="2.5rem">
      <ProfitLossOverviewChartTemplate
        creditFacilityId={creditFacilityId}
        chartTitle="Charge Off & Delinquent"
        chartConfig={chargeOffAndDelinquentOverviewChartConfig}
      />
      <ProfitLossOverviewChartTemplate
        creditFacilityId={creditFacilityId}
        chartTitle="Days Past Due"
        chartConfig={daysPastDueChartConfig}
      />
      <PortfolioCoreBorrowingBaseChartTemplate
        creditFacilityId={creditFacilityId}
        chartTitle="Collections Account"
        chartConfig={collectionsAccountChartConfig}
      />
      <Flex direction="column" gap="1rem">
        <Typography variant="section-title" trim>
          By Vintage
        </Typography>
        <RepaymentsVintageChart creditFacilityId={creditFacilityId} />
        <ProfitLossVintageChartTemplate
          creditFacilityId={creditFacilityId}
          chartTitle="Charge Off By Vintage"
          field="chargedOffPercentageOfTotalVintageCalcValue"
          fieldType="percentage"
          yAxisLabel="Percent of Total Exposure"
        />
        <ProfitLossVintageChartTemplate
          creditFacilityId={creditFacilityId}
          chartTitle="Delinquency By Vintage"
          field="delinquentPercentageOfTotalVintageCalcValue"
          fieldType="percentage"
          yAxisLabel="Percent of Total Exposure"
        />
      </Flex>
    </Flex>
  );
};
